<script setup lang="ts">
  import type { MpfPaginationEmits, MpfPaginationProps } from './MpfPagination.props';
  import { mpfPaginationDefaults } from './MpfPagination.props';

  withDefaults(defineProps<MpfPaginationProps>(), mpfPaginationDefaults);
  const emit = defineEmits<MpfPaginationEmits>();

  defineOptions({
    name: 'MpfPagination',
  });
</script>

<template>
  <nav class="mpf-pagination" aria-label="Pagination">
    <ul class="mpf-pagination__list">
      <li v-if="hasPrevious" class="mpf-pagination__item mpf-pagination__item--previous">
        <button
          type="button"
          class="mpf-pagination__link"
          :aria-label="previousAriaLabel || previousLabel"
          @click="emit('previous')"
        >
          <span class="mpf-pagination__title">Previous</span>
          <span class="mpf-u-visually-hidden">:</span>
          <span class="mpf-pagination__page">{{ previousLabel }}</span>
        </button>
      </li>
      <li v-if="hasNext" class="mpf-pagination__item mpf-pagination__item--next">
        <button
          type="button"
          class="mpf-pagination__link"
          :aria-label="nextAriaLabel || nextLabel"
          @click="emit('next')"
        >
          <span class="mpf-pagination__title">Next</span>
          <span class="mpf-u-visually-hidden">:</span>
          <span class="mpf-pagination__page">{{ nextLabel }}</span>
        </button>
      </li>
    </ul>
  </nav>
</template>

<style lang="scss" scoped>
  @use './MpfPagination.scss';
</style>
